import { ParameterType } from '@/study-search/enums';
import { FilterDefinition } from './FilterDefinition';

export class OrganisationFilterDefinition extends FilterDefinition {
	public constructor() {
		super(ParameterType.ORGANISATIONS, [], []);
	}
}

export default new OrganisationFilterDefinition();
